import * as React from 'react';
import styled from 'styled-components';
import IImage from '../../Entities/Image';
import Image from '../Image/Image';

const Divider = styled.span`
  height: 2px;
  display: block;
  width: 4rem;
  background: #d8514b;
  margin: 0 auto;
`;

const Intro = styled.div`
  text-align: center;
  padding-bottom: 1rem;
  font-size: 1.15rem;
`;

interface Props {
  title: string;
  image?: IImage;
  description?: string;
}

export default (props: Props) => (
  <Intro>
    <h1>
      {props.image && <Image {...props.image} maxWidth="350px" />}
      {!props.image && props.title}
    </h1>
    <Divider />
    {props.description && <div dangerouslySetInnerHTML={{ __html: props.description }} />}
  </Intro>
);



// WEBPACK FOOTER //
// ./src/components/Intro/Intro.tsx